/* eslint-disable @typescript-eslint/no-explicit-any */
import { IAxiosError } from '@shared/types/AxiosError';
import { useQuery } from '@tanstack/react-query';

import { getUserInfo, IGetUserInfo } from '../services';

export function useGetUserInfo(config?: any) {
  const { data, isLoading, isFetching, error, ...query } = useQuery(
    ['getUserInfo'],
    () => getUserInfo(),
    config,
  );

  return {
    data: data?.data || ({} as IGetUserInfo),
    isFindingUserInfo: isLoading || isFetching,
    errorFindingUserInfo: error as IAxiosError,
    ...query,
  };
}
export const QUERY_KEY_GET_USER_INFO = ['getUserInfo'];
